<template>
	<div class="cdkey">
		<div style="margin-bottom: 20px;">
			<h1>
				<span style="margin-right: 20px;">CDkey列表</span>
				<el-button type="primary" @click="$router.back()">返回</el-button>
				<el-button @click="handleExport">导出cdkey</el-button>
			</h1>
		</div>
		<el-row>
			<el-input v-model="query.cdk" clearable placeholder="请输入CDK" style="width: 200px; margin-right: 20px;"></el-input>
			<el-select v-model="query.status" style="margin-right: 20px;">
				<el-option :value="1" label="正常"></el-option>
				<el-option :value="2" label="已使用"></el-option>
				<el-option :value="3" label="冻结"></el-option>
				<el-option :value="4" label="作废"></el-option>
			</el-select>
			<el-button type="primary" @click="getTableData">搜索</el-button>
		</el-row>
		<div>
			<el-table :data="dataList" v-loading="loading">
				<el-table-column prop="id" label="ID"></el-table-column>
				<el-table-column prop="name" label="批次名称"></el-table-column>
				<el-table-column prop="price" label="面值"></el-table-column>
				<el-table-column prop="cdk" label="CDKey"></el-table-column>
				<el-table-column prop="status" label="状态">
					<template slot-scope="{ row }">
						<el-tag v-if="row.status === 1">未使用</el-tag>
						<el-tag type="success" v-if="row.status === 2">已使用</el-tag>
						<el-tag type="info" v-if="row.status === 3">已冻结</el-tag>
						<el-tag type="danger" v-if="row.status === 4">已作废</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="user_id" label="使用用户ID"></el-table-column>
				<el-table-column prop="use_time" label="使用时间"></el-table-column>
				<el-table-column prop="created_at" label="创建时间"></el-table-column>
				<el-table-column prop="action" label="操作">
					<template slot-scope="{ row }" v-if="row.status !== 2">
						<el-button @click="handleEdit(row)">修改状态</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog :visible.sync="visibleEdit" title="修改CDkey状态" width="240px">
			<!-- <el-form
				:model="formData"
				label-width="100px"
				:rules="rules"
				ref="addForm"
			> -->
			<el-select v-model="cdkeyStatus">
				<el-option :value="1" label="未使用"></el-option>
				<!-- <el-option :value="2" label="已使用"></el-option> -->
				<el-option :value="3" label="已作废"></el-option>
				<el-option :value="4" label="未作废"></el-option>
			</el-select>
			<!-- </el-form> -->
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="visible = false">取 消</el-button>
				<el-button
					size="small"
					type="primary"
					@click="submit"
					:loading="buttonLoading"
					>确 定</el-button
				>
			</span>
		</el-dialog>
		<el-pagination
			background
			:page-size="dataMeta.per_page || 15"
			:total="dataMeta.total || 0"
			:current-page="dataMeta.current_page"
			@current-change="handlePageChange"
			v-if="dataMeta && dataMeta.total > dataMeta.per_page"
		></el-pagination>
	</div>
</template>

<script>
import table from '../../mixins/table'
import { patchData, server } from '../../http'
// import { postData } from '../../http'
export default {
	props: {
		id: String,
		default: undefined
	},
	mixins: [table],
	data() {
		return {
			config: {
				getUrl: `cdk_item/${this.id}`,
				delUrl: 'cdk'
			},
			query: {
				cdk: undefined,
				status: undefined
			},
			visibleEdit: false,
			buttonLoading: false,
			cdkeyStatus: 1,
			currentId: undefined
		}
	},
	methods: {
		handleEdit(row) {
			this.currentId = row.id
			this.cdkeyStatus = row.status
			this.visibleEdit = true
		},
		handleExport() {
			this.$prompt('请输入密码', {
				confirmButtonText: '导出',
				cancelButtonText: '取消',
				inputValue: 'qq61714189'
			}).then(({ value }) => {
				window.open(`${server}cdk_export/${this.id}?password=${value}`)
			})
		},
		submit() {
			this.buttonLoading = true
			patchData(`cdk_item/${this.currentId}`, {
				status: this.cdkeyStatus
			})
				.then(res => {
					this.$message.success('修改成功')
					this.visibleEdit = false
					this.getTableData()
				})
				.finally(() => {
					this.buttonLoading = false
				})
		}
	}
}
</script>

<style>
</style>
